import { render } from "./TestaMenu.vue?vue&type=template&id=4563d623"
import script from "./TestaMenu.vue?vue&type=script&lang=js"
export * from "./TestaMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__